/**
 * Manual scroll restoration contract (see docs/04-motion.md).
 *
 * On refresh the browser would otherwise restore `scrollY` into the pre-GSAP
 * CSS runway before the hero pin spacer exists. We own restoration: persist
 * on `pagehide`, hold at 0 until Lenis + the hero scene are ready, then jump.
 */

/** `sessionStorage` key for the pending scroll Y to restore after layout is stable. */
export const SCROLL_RESTORATION_STORAGE_KEY = 'sotwb:scroll-y' as const;
